var map = {
	"./AAVE.png": "b8c3",
	"./ADA.png": "5dc1",
	"./BCH.png": "acb9",
	"./BTC.png": "b6be",
	"./DASH.png": "fff4",
	"./DOGE.png": "e0ea",
	"./DOT.png": "8aa4",
	"./EOS.png": "ab26",
	"./ETH.png": "051e",
	"./KMD.png": "1aaa",
	"./LINK.png": "7111",
	"./LTC.png": "31e6",
	"./LTCT.png": "7a3c",
	"./TRX.png": "64ac",
	"./UNI.png": "f46e",
	"./USDT.png": "c6e5",
	"./XMR.png": "dbc9",
	"./XRP.png": "0f19",
	"./XTZ.png": "842b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2de1";